import adminClasses from "../../../landing-pages/admin/admin.module.css";
import { Controller, useForm } from "react-hook-form";
import { Autocomplete, Button, FormControl, TextField } from "@mui/material";
import CityRequestModel from "../../../models/admin/city/request/CityRequestModel";
import IdNameModel from "../../../models/common/IdNameModel";
import toasterUtils from "../../../utils/toaster-utils";
import { FORM_SELECT_RULE, OBJECT_DESCRIPTION_RULE, OBJECT_NAME_RULE } from "../../../utils/validation-utils";

interface CityProps {
    objCity: CityRequestModel;
    countryList: IdNameModel[];
    actionType: string;
    onCloseCity: () => void;
    onCitySave: (objCity: CityRequestModel) => void;
}

const CityCeateComponent = (props: CityProps) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
        control
    } = useForm<CityRequestModel>({
        mode: "onChange",
        defaultValues: props.objCity
    });

    const onSubmit = (formData: CityRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onCitySave(formData);
    }

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="countryId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.countryList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.countryList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Country" size="small" required margin="normal" fullWidth error={!!errors.countryId} helperText={errors.countryId?.message}
                                            />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.cityName}>
                                <TextField label="City Name" size="small"
                                    {...register("cityName", OBJECT_NAME_RULE)} error={!!errors.cityName} helperText={errors.cityName?.message} autoComplete="off" required />
                            </FormControl>
                        </div>
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.description}>
                                <TextField label="Description" size="small" multiline rows={3}
                                    {...register("description", OBJECT_DESCRIPTION_RULE)} error={!!errors.description} helperText={errors.description?.message} autoComplete="off" />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Save
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseCity}>
                                Close
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default CityCeateComponent;